import { useEffect, useState } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Select, Button, Input } from "components/core";
import { PageWrapper } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { fetchBackend } from "helpers";
import { optionsListReasons } from "constants/index";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SchemaMailbox = yup.object().shape({
  type: yup.string().required("Seleccione el motivo"),
  suggestion: yup.string().required("Ingrese una sugerencia"),
});

const Mailbox = ({ setLoading }) => {
  const [isChargin, setCharge] = useState(false);
  const gContext = useGlobalContext();

  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(SchemaMailbox),
  });

  useEffect(() => {
    setLoading(false);
  }, []);

  const addSuggestion = async (obj) => {
    const { error } = await fetchBackend({
      method: "post",
      url: "suggestion",
      data: obj,
    });

    if (!error) {
      setCharge(false);
      gContext.toggleAlert({ message: "Sugerencia registrada con exito" });
      gContext.toggleModal({
        title: "Aportacion enviada",
        description: "Gracias por ayudarnos a mejorar",
        okText: "OK",
        onOk: () => {
          gContext.toggleModal(null);
        },
      });
    } else {
      setCharge(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar registrar la sugerencia, intente nuevamente",
        type: "error",
      });
    }
  };

  const onSubmit = async (form, e) => {
    const user = gContext.currentUser?._id || "";
    setCharge(true);
    await addSuggestion({ ...form, user });
    e.target.reset();
  };

  return (
    <PageWrapper
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Ayudanos a mejorar</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)} className="w-100">
        <Row>
          <Select
            name="type"
            valueOption="id"
            labelOption="title"
            placeholder="Elige un motivo"
            ref={register}
            disabled={isChargin}
            options={optionsListReasons}
            error={errors.type?.message}
          />
          <Input
            name="suggestion"
            type="textarea"
            placeholder="Cuentanos"
            ref={register}
            disabled={isChargin}
            error={errors.suggestion?.message}
          />
          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              loading={isChargin}
            >
              Enviar
            </Button>
          </Col>
        </Row>
      </form>
    </PageWrapper>
  );
};

export default withLoader(Mailbox, "Cargando buzón");
